export const SET_TOKEN = 'SET_TOKEN'
export const SET_SALES_FLAG = 'SET_SALES_FLAG'



// WEBPACK FOOTER //
// ./src/store/mutations-types.js